import { twMerge } from "tailwind-merge";
import { clsx } from "clsx";
import type { HTMLAttributes, ReactNode } from "react";

interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  title?: ReactNode;
  actions?: ReactNode;
}

export default function Card({ title, actions, className, children, ...rest }: CardProps) {
  return (
    <div
      className={twMerge(
        clsx("rounded-xl border border-border bg-surface-elev p-6 text-text-primary"),
        className,
      )}
      {...rest}
    >
      {(title || actions) && (
        <div className="mb-4 flex items-center justify-between">
          {title && <h2 className="text-base font-semibold">{title}</h2>}
          {actions}
        </div>
      )}
      {children}
    </div>
  );
}
